<div class="flex flex-col h-full overflow-hidden print-hidden">
  @if (!verticalBranches) {
    <div class="flex-none" *ngxPermissionsOnly="'User.Branch.View'">
      @if (sessionService.session) {
        <ui-branch-tabs />
      }
    </div>
  }
  <div class="flex-none">
    <ui-header [session]="sessionService.session" [releaseNotes]="false" (releaseNotesClick)="onReleaseNotes()">
      @if (webshopService.showShoppingCartButton()) {
        <ng-template #addon>
          <app-shopping-cart-button />
        </ng-template>
      }
    </ui-header>
  </div>
  <div class="flex-none">
    @if (sessionService.session) {
      <ui-global-message />
    }
  </div>
  <div class="grow overflow-hidden" [class.flex]="verticalBranches">
    @if (verticalBranches) {
      <div class="flex-none" *ngxPermissionsOnly="'User.Branch.View'">
        @if (sessionService.session) {
          <ui-branch-vertical />
        }
      </div>
    }
    <div class="grow h-full overflow-hidden">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

@if (printService.isPrinting) {
  <app-print-pallet></app-print-pallet>
}

<ui-loading />

<p-scrollTop icon="far fa-chevron-up" [threshold]="2000" />
<p-confirmDialog #cd [header]="'COMMON.CONFIRM' | translate" [style]="{ width: '40rem' }" icon="far fa-exclamation-triangle"></p-confirmDialog>

<p-toast class="custom-toast" position="bottom-right">
  <ng-template let-message #message>
    <div class="flex items-center message-content">
      <i [class]="message.icon + ' fa-2x mt-1'"></i>
      <div class="message">{{ message.detail }}</div>
    </div>
  </ng-template>
</p-toast>

<app-assistant-chat-widget *ngxPermissionsOnly="'Module.ServiceAndSupport.Assistant.Chat'" />

@defer (when displayDialog) {
  <app-releasenotes-dialog [displayDialog]="displayDialog" (hideDialog)="onDialogHide()" />
}
